import { Flex } from "@radix-ui/themes";
import Select from "@/components/shared/select";

// Generate months array
const months = [
  { value: "0", label: "January" },
  { value: "1", label: "February" },
  { value: "2", label: "March" },
  { value: "3", label: "April" },
  { value: "4", label: "May" },
  { value: "5", label: "June" },
  { value: "6", label: "July" },
  { value: "7", label: "August" },
  { value: "8", label: "September" },
  { value: "9", label: "October" },
  { value: "10", label: "November" },
  { value: "11", label: "December" },
];

// Generate years array (current year and previous 5 years)
const currentYear = new Date().getFullYear();
const years = Array.from({ length: 6 }, (_, i) => {
  const year = currentYear - i;
  return { value: year.toString(), label: year.toString() };
});

interface BillingHeaderActionsProps {
  selectedMonth: number;
  selectedYear: number;
  setSelectedMonth: (month: number) => void;
  setSelectedYear: (year: number) => void;
}

export function BillingHeaderActions({
  selectedMonth,
  selectedYear,
  setSelectedMonth,
  setSelectedYear,
}: BillingHeaderActionsProps) {
  const handleMonthChange = (value: string) => {
    setSelectedMonth(parseInt(value));
  };

  const handleYearChange = (value: string) => {
    setSelectedYear(parseInt(value));
  };

  return (
    <Flex gap="2" align="center">
      <Select
        options={months}
        value={selectedMonth.toString()}
        onChange={handleMonthChange}
        placeholder="Select month"
      />

      <Select
        options={years}
        value={selectedYear.toString()}
        onChange={handleYearChange}
        placeholder="Select year"
      />
    </Flex>
  );
}
